import { styled, Box, Radio, Typography } from '@mui/material'
import theme from 'lib/theme'

export const RefundCellWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'getBackgroundColor',
})<{ getBackgroundColor: string }>(({ getBackgroundColor }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: getBackgroundColor,
  height: '20px',
  width: '64px',
  borderRadius: '10px',
  marginBottom: theme.spacing(1),
}))

export const RequiredPill = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.commonColors.darkGrey};
  border-radius: 12px;
  padding: 4px 8px;
  margin-left: ${theme.spacing(1)};
`

export const RadioBtn = styled(Radio)(() => ({
  '&.Mui-disabled .MuiSvgIcon-root': {
    fill: theme.palette.action.disabled,
  },
  '&.Mui-checked .MuiSvgIcon-root:nth-of-type(2)': {
    fill: theme.palette.icon.selected,
  },
  '.MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
  },
}))

export const ProductColWrapper = styled(Box)({
  height: theme.spacing(9),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(1),
})

export const TooltipStyling = {
  height: '80px',
  maxWidth: '200px',
  backgroundColor: theme.palette.commonColors.white,
  color: theme.palette.text.primary,
  boxShadow: 2,
  overflowX: 'scroll',
}

export const ProductName = styled(Typography, {
  shouldForwardProp: (props) =>
    props !== 'substituted' && props !== 'hoverStatus',
})<{ substituted: boolean; hoverStatus: boolean }>(
  ({ substituted, hoverStatus }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: substituted ? 'line-through' : 'none',
    '&:hover': { cursor: hoverStatus ? 'pointer' : 'auto' },
  })
)

export const PickingStatusWrapper = styled(Box)({
  height: theme.spacing(9),
  maxWidth: '100px',
  display: 'flex',
  padding: theme.spacing(1),
})

export const ReplaceColWrapper = styled(Box)({
  height: theme.spacing(9),
  maxWidth: '100px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  padding: theme.spacing(1),
})

export const ProductNoteStyling = {
  height: '88px',
  maxWidth: '180px',
  backgroundColor: theme.palette.commonColors.white,
  color: theme.palette.text.primary,
  boxShadow: 2,
  overflowX: 'scroll',
}

export const RefundTextStyling = styled(Typography)({
  display: 'inline',
  color: theme.palette.commonColors.white,
  fontWeight: 'bold',
  fontSize: '10px',
  '&:hover': {
    cursor: 'pointer',
  },
})
